$(function() {

	var isLocalEnv = window.location.hostname === 'local.2040energy.com';
	
	function setHeroBounds() {
		// Hero image is 3840 x 2160
		// Top left of the product is at 1080,580
		// Product size is 1692 x 1150
		var heroTotalWidth = 3840;
		var heroTotalHeight = 2160;
		var heroProductX = 1080
		var heroProductY = 580
		var heroProductWidth = 1692
		var heroProductHeight = 1150

		// We want the product to fill either 50% of the viewport height or 100% of its width (whichever is smaller)
		var viewportWidth = $(window).width();
		var viewportHeight = $(window).height();
		var heroProductScaleBasedOnHeight = viewportHeight * 0.5 / heroProductHeight;
		var heroProductScaleBasedOnWidth = viewportWidth * 0.95 / heroProductWidth;
		var heroProductScale = Math.min(heroProductScaleBasedOnHeight, heroProductScaleBasedOnWidth);

		// We want the top of the product to be partway down the page. 11rem seems to be good for all sizes.
		var targetProductY = parseInt($("body").css('font-size')) * 11;

		$(".background,.background-overlay").css('background-size', Math.round(heroTotalWidth * heroProductScale));
		$(".background,.background-overlay").css('background-position-y', Math.round(targetProductY - heroProductY * heroProductScale));
		$(".hero-placeholder").css('height', Math.round(heroProductHeight * heroProductScale));

		$("hr.hero-separator").each(function() {
			var $this = $(this);
			$this.css('margin-top', '0');
			$this.css('margin-bottom', '0');
			var hrTop = $this.offset().top;
			var visibleHeight = $(window).height();
			if (visibleHeight > hrTop) {
				var halfHeightDiff = (visibleHeight - hrTop) / 2;
				halfHeightDiff = Math.max(halfHeightDiff, 20);
				$this.css('margin-top', '' + halfHeightDiff + 'px');
				$this.css('margin-bottom', '' + halfHeightDiff + 'px');
			}
		});
	}

	setHeroBounds();
	$(".background").css('background-image', "url('/img/2023/06/hero-hq-bg.jpg')");
	$(".background-overlay").css('background-image', "url('/img/2023/06/hero-hq.jpg')");
	setHeroOpacity();

	function setHeroOpacity() {
		var viewportHeight = $(window).height();
		var opacity = Math.max(0, 1 - $(window).scrollTop() / (0.75 * viewportHeight));
		$(".background-overlay").css('opacity', opacity);
	}

	$(window).on('scroll', function() {
		$(".background-overlay").css('transition', 'none');
		setHeroOpacity();
	})

	$(window).on('resize', function() {
		setHeroBounds();
	});

	$(".main-container").each(function() {
		$(this).css('visibility', 'visible');
		$(this).css('min-height', $(window).height());
	})

	// Animate scroll for # links
	$('a[href^="#"]').on('click',function (e) {
		e.preventDefault();

		var targetName = this.hash.substring(1);
		if (!targetName) {
			return;
		}

		var $target = $('#' + targetName);
		if (!$target.length) {
			$target = $('a[name="' + targetName + '"]');
		}

		$('html, body').stop().animate({
			'scrollTop': $target.offset().top
		}, 1000, 'swing');
	});			

	// Populate mailto links
	$("a.mailto").each(function() {
		this.href = 'mailto:' + this.innerText;
	});

	// Open PDF files in a new window
	$("a").each(function() {
		if (/\.(pdf|doc)$/.test(this.href)) {
			this.target = "_blank";
		}
	});

	var $heroImg = $(".product-hero img.hero-image");
	if ($heroImg.length) {
		var windowHeight = $(window).height();
		var $learnMore = $("#learn-more");
		var adjustment = $learnMore.offset().top - windowHeight;
		if (adjustment > 0) {
			var imgHeight = $heroImg.height();
			$heroImg.css('width', 100 * (imgHeight - adjustment) / imgHeight + '%');
		}
	}

	$("a.cta-wefunder").on('click', function(evt) {
		gtag('event', 'wefunder_click', { });
	})

	$("a.cta-subscribe").on('click', function(evt) {
		gtag('event', 'subscribe_click', { });
	})

	$("#mc-embedded-subscribe-form").on('submit', function(evt) {
		gtag('event', 'email_signup', { });
	});

	function submitForm($form) {
		gtag('event', `${$form.attr('data-ga-id')}_submit`, { });

        var formData = $form.serializeArray();
		var jsonData = {};
        $.each(formData, function () {
            if (jsonData[this.name]) {
                if (!jsonData[this.name].push) {
                    jsonData[this.name] = [jsonData[this.name]];
                }
                jsonData[this.name].push(this.value || '');
            } else {
                jsonData[this.name] = this.value || '';
            }
        });		

		var $submit = $form.find('[type=submit]');
		$submit.attr('disabled', 'disabled');
		$form.find(".alert").addClass('hidden');
		$.ajax({
			url: $form.attr('action'),
			method: $form.attr('method'),
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(jsonData),
			processData: false,
			success: function(data, textStatus, jqXHR) {
				if ($form.hasClass('reserve-form')) {
					var reservationId = data.id;
					var emailAddress = jsonData.emailAddress;
					const paymentLinkRoot = isLocalEnv ?
						'https://buy.stripe.com/test_aEU5nb9nX4Gdba8144' :
						'https://buy.stripe.com/00gbJ098J4vV55C4gg';
					const paymentLink = paymentLinkRoot + `?prefilled_email=${encodeURIComponent(emailAddress)}&client_reference_id=${encodeURIComponent(reservationId)}`
					window.location = paymentLink;
				} else {
					$form.find(".alert-success").removeClass('hidden');
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				$submit.removeAttr('disabled');
				$form.find(".alert-danger").removeClass('hidden');
			}			
		});
	}

	// Require .extra fields to be empty
	$("form").not("#mc-embedded-subscribe-form").on('submit', function(event) {
		event.preventDefault();
		var $form = $(this);
		if ($form.find(".extra").text()) {
			return false;
		}

		if (window.grecaptcha) {
			grecaptcha.ready(function() {
				grecaptcha.execute('6Ld6yUwqAAAAAOEdwWxTH8uQF2Rm3-oNwNQq27-U', {action: 'submit'}).then(
					function(token) {
						$form.find("[name=grecaptchaToken]").val(token);
						submitForm($form);
					},
					function (err) {
						console.log("grecaptcha failure: " + err);
						$form.find(".alert-danger").removeClass('hidden');
					});
			  });			
		} else {
			submitForm($form);
		}
	});

	$("a.share-button-email").each(function() {
		var title = $.trim($("h1.post-title").text());
		var firstPara = $(this).attr('data-message') || "Check out this article:"
		var body = firstPara + "%0D%0A%0D%0A" + window.location.href;
		$(this).attr('href', "mailto:?subject=" + title + "&body=" + body);
	});
});
